<template>
  <div class="uk-flex-center" uk-grid>
    <div class="uk-width-1-1 uk-text-center" uk-scrollspy="target: > *; cls: uk-animation-fade uk-animation-slide-bottom-small;">
      <h2>{{ $t('frontend-cinquanta3.store_locator.' + zoneLabel + '.title') }}</h2>
      <p class="uk-font-light">{{ $t('frontend-cinquanta3.store_locator.' + zoneLabel + '.text') }}</p>
    </div>
    <div class="uk-width-1-1 uk-text-center" uk-scrollspy="target: > *; cls: uk-animation-fade uk-animation-slide-bottom-small; delay: 250">
      <div class="form form--underline form--thin uk-width-1-2@m uk-width-2-5@l uk-margin-auto-left uk-margin-auto-right">
        <div v-if="global" class="uk-margin-medium">
          <div class="dropdown-select" data-dropdown-select>
            <div class="dropdown-select__placeholder">{{ $t('frontend-cinquanta3.store_locator.worldwide.select_continent') }}</div>
            <div class="dropdown-select__dropdown">
              <ul class="dropdown-select__list">
                <li v-for="(zone, key) in zones">
                  <div class="dropdown-select__option" @click="selectContinent(zone)">{{ $t('frontend-cinquanta3.store_locator.worldwide.' + key) }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="uk-margin-medium" :id="'item-'+randomId" v-show="allZones || ! global">
          <div class="dropdown-select" data-dropdown-select>
            <div class="dropdown-select__placeholder">{{ $t('frontend-cinquanta3.store_locator.' + zoneLabel + '.select') }}</div>
            <div class="dropdown-select__dropdown">
              <ul class="dropdown-select__list">
                <li v-for="(zone) in allZones">
                  <div class="dropdown-select__option" @click="selectZone(zone.code,zone.name)">{{ zone.name }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Results -->
    <div class="uk-width-1-1 uk-width-3-5@l" v-show="selectedZone">
      <div class="uk-h3 uk-text-center uk-margin-large-bottom">{{ $t('frontend-cinquanta3.store_locator.contact_agency') }}</div>
      <div class="uk-child-width-1-1 uk-flex-center uk-grid-large" uk-grid uk-scrollspy="target: > *; cls: uk-animation-fade uk-animation-slide-bottom-small; delay: 250">
        <div v-for="agent in filteredAgents">
          <div class="store-locator-card uk-grid" uk-grid>
            <div class="uk-width-expand@s">
              <div class="store-locator-card__title">{{ agent.name }}</div>
              <div class="store-locator-card__text">
                <span>{{ agent.area_description }}</span>
                {{ agent.description }}
              </div>
            </div>
            <div class="uk-width-1-3@s store-locator-card__contacts">
              <a :href="'tel:'+ agent.phone_number"
                 :title="$t('frontend-cinquanta3.store_locator.call', {'name' : agent.name})">{{ agent.phone_number }}</a>
              <a :href="'mailto:'+ agent.email + '?subject=' + $t('frontend-cinquanta3.store_locator.write_to_subject')"
                 :title="$t('frontend-cinquanta3.store_locator.write_to', {'name' : agent.name})">{{ agent.email }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    zones: {
      type: [Array, Object],
    },
    agents: {
      type: Array,
    },
    global: {
      type: Boolean,
    },
  },
  data() {
    return {
      allZones: null,
      selectedZone: null,
      zoneLabel: null,
      randomId: null,
    }
  },
  mounted() {
    this.randomId = 'results-' + (Math.floor((Math.random() * 100) + 1));
    if (this.global) {
      this.zoneLabel = 'worldwide';
    } else {
      this.allZones = this.zones;
      this.zoneLabel = 'italy';
    }
  },
  computed: {
    filteredAgents() {
      let agents = [];
      let self = this;
      if (this.selectedZone !== null && this.selectedZone !== undefined) {
        this.agents.forEach(function (a) {
          if (a.zone_code === self.selectedZone) {
            agents.push(a)
          }
        });
      }
      return agents;
    },
  },
  methods: {
    selectContinent(countries) {
      this.allZones = countries;
      this.selectedZone = null;
      let placeholder = document.querySelector('#item-' + this.randomId + ' .dropdown-select__placeholder');
      if (placeholder) {
        placeholder.innerHTML = this.$t('frontend-cinquanta3.store_locator.' + this.zoneLabel + '.select');
      }
    },
    selectZone(code, name) {
      this.selectedZone = code;
      let wrapper = document.getElementById('item-' + this.randomId);
      let child = wrapper.children[0];
      if (child.classList.contains('uk-active')) {
        child.classList.remove('uk-active')
        let placeholder = document.querySelector('#item-' + this.randomId + ' .dropdown-select__placeholder');
        if (placeholder) {
          placeholder.innerHTML = name;
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/cinquanta3/assets/js/theme-components/AgentsFinder.vue